import React from "react";
import type { TranscriptItem } from "../hooks/useTranslator";
import { useUiLang } from "../../../context/UiLangContext";

interface MinutaViewProps {
  meetingTranscript: TranscriptItem[];
  recording: boolean;
  onOpenSummary: () => void;
}

export const MinutaView: React.FC<MinutaViewProps> = ({
  meetingTranscript,
  recording,
  onOpenSummary,
}) => {
  const { uiLang } = useUiLang();
  const isEn = uiLang === "en";
  return (
    <div className="flex-1 flex flex-col p-6 overflow-hidden h-full">
      <div className="flex-1 bg-[var(--surface)] border border-[var(--border)] rounded-xl p-5 md:p-8 flex flex-col min-h-0 shadow-lg transition-colors duration-300">
        <p className="text-[10px] font-bold tracking-widest font-mono text-[var(--text-dim)] uppercase mb-4 text-center">
          {isEn ? "Meeting Transcription History (Minutes Only)" : "Historial de Transcripción de la Reunión (Solo Minuta)"}
        </p>

        <div className="flex-1 overflow-y-auto space-y-3.5 pr-2 font-mono scroll-bg scrollbar-thin scrollbar-thumb-white/10 scrollbar-track-transparent">
          {meetingTranscript.length === 0 ? (
            <p className="text-xs text-[var(--text-dim)] italic text-center py-20">
              {isEn ? "Meeting history will appear here when you start..." : "El historial de la reunión aparecerá aquí al comenzar..."}
            </p>
          ) : (
            meetingTranscript.map((item, index) => (
              <div
                key={index}
                className={`text-xs leading-relaxed p-1.5 rounded transition-all ${
                  item.isMic ? "bg-emerald-500/5 text-emerald-400" : "text-[var(--text-muted)]"
                }`}
              >
                <span className="text-[var(--text-dim)] mr-2.5 font-sans select-none">[{item.timestamp}]</span>
                <span className="select-text">{item.orig}</span>
              </div>
            ))
          )}
        </div>

        {meetingTranscript.length > 0 && !recording && (
          <div className="mt-5 pt-4 border-t border-[var(--border)] flex justify-center">
              <button
                onClick={onOpenSummary}
                className="flex items-center gap-2 px-5 py-2.5 bg-[var(--accent)] hover:bg-[#006ee6] text-white font-semibold text-xs rounded-lg shadow-lg active:scale-95 transition-all"
              >
                <span>📝</span>
                {isEn ? "Generate Minutes & Agreements with AI" : "Generar Minuta & Acuerdos con IA"}
              </button>
          </div>
        )}
      </div>
    </div>
  );
};
